import { connect } from "react-redux";
import {
  AddVehicleByLicensePlateVinProps,
  AddVehicleByLicensePlateVin as Component,
} from "./AddVehicleByLicensePlateVin.component";
import { RootState } from "../../../reducers";
import { getLicensePlateVinLookupMethod } from "../../../selector";

const mapStateToProps = (state: RootState): Pick<AddVehicleByLicensePlateVinProps, "lookupMethod"> => ({
  lookupMethod: getLicensePlateVinLookupMethod(state),
});

export const AddVehicleByLicensePlateVin = connect(mapStateToProps, {})(Component);
